import { render, staticRenderFns } from "./DisplayOverviewReport.vue?vue&type=template&id=2a773b2d&scoped=true"
import script from "./DisplayOverviewReport.vue?vue&type=script&lang=js"
export * from "./DisplayOverviewReport.vue?vue&type=script&lang=js"
import style0 from "./DisplayOverviewReport.vue?vue&type=style&index=0&id=2a773b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a773b2d",
  null
  
)

export default component.exports